<template>
  <Content id="Classes">
    <div slot="search">
      <Form :label-width="50" :model="search" id="searchForm">
        <Row>
          <Col>
            <FormItem  label="学校名称"  prop="schoolId" :label-width="75">
              <el-select v-model.trim="search.schoolId" placeholder="学校名称"
                         clearable filterable size="small" transfer="true"
                         :popper-append-to-body="false" @change="changeSchool" style="width:100%">
                <el-option v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id"
                           @click.native="handleShoolChange(item)" style="width:100%"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem  label="年级"  prop="gradeId">
              <el-select v-model.trim="search.gradeId" placeholder="年级"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false"
                         @change="changeGrade" style="width:100%">
                <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id"
                           @click.native="handleGradeChange(item)" style="width:100%"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem  label="班级"  prop="classesId">
              <el-select v-model.trim="search.classesId" placeholder="班级"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false" style="width:100%">
                <el-option v-for="item in classesList" :key="item.id" :label="item.name" :value="item.id"
                           @click.native="handleClassChange(item)" style="width:100%"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="状态">
              <Select v-model="search.status" style="width: 100%;" :clearable="true">
                <Option v-for="item in enums.status" :value="item.value" v-bind:key="item.value" style="width: 100%;">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <div style="display:flex;">
              &nbsp;&nbsp;<Button type="primary" @click="query">查询</Button>
            </div>
          </Col>
        </Row>

      </Form>

      <div slot="extra" style="margin-bottom: 5px; display: flex;" >
        <Button size="small" icon="md-add" @click="handleCreate" type="primary">新增</Button>
        <Button size="small" style="margin-left: 5px;" icon="ios-share-outline" @click="importData" type="primary">导入</Button>
      </div>
    </div>

    <el-table :data="dataList" ref="singleTable" style="width: 100%;" :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow" highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

      <el-table-column fixed align="center" prop="schoolName" label="学校名称" min-width="200"/>
      <el-table-column align="center" prop="gradeName" label="年级" min-width="110"/>
      <el-table-column align="center" prop="name" label="班级" min-width="150"/>
      <el-table-column align="center" prop="contactPerson" label="联系人" min-width="80"/>
      <el-table-column align="center" prop="telphone" label="联系电话" min-width="120"/>
      <el-table-column align="center" prop="operator" label="最后操作人" min-width="150">
        <template #default="{ row }">
          <div>{{ row.operatorAccount }}</div>
          <div>{{ row.operator }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="updateTime" label="最后操作时间" min-width="160"/>
      <el-table-column align="center" prop="status" label="状态"  min-width="60">
        <template slot-scope="{row}">
          <el-switch v-model="row.status" :active-value="1" :inactive-value="2" @change="handleEditStatus(row, null, row.status)"/>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" prop="operation" label="操作"  min-width="150" id="elPopoverVisible">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="handleEdit(row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 30, 50, 100]"
          @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

    <Modal v-model="editWindow" width="50%" :title="windowTitle" :styles="{'top':'60px'}" :mask-closable="false">
      <ClassesEdit ref="edit" @on-submit="handleSubmit"/>
      <div slot="footer">
        <Button type="primary" @click="submit">确定</Button>
        <Button @click="editWindow = false">取消</Button>
      </div>
    </Modal>

    <el-dialog title="导入班级" :visible.sync="importWindow" width="400px" custom-class="my-dialog"
               :destroy-on-close="true" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-upload action="#" :limit="1" class="upload-demo" drag multiple :auto-upload="false"
                 :on-change="handleChange" :on-remove="handleRemove"
                 :file-list="fileList">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
<!--        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
      </el-upload>
      <div><a @click.stop="template()">文件模版</a></div>

      <span slot="footer" class="dialog-footer">
          <el-button  @click="handleCancle">取 消</el-button>
          <el-button type="primary" @click="handleUpload" :disabled="importDisabled">确 定</el-button>
        </span>
    </el-dialog>


  </Content>
</template>
<script>
import { _page, _template, _upload, _updateStatus} from "@/services/classes/class";
import {_schoolsList, _gradesList, _classesList} from "@/services/studentManage/studentManage";
import ClassesEdit from "./ClassesEdit";
import {enums} from "@/services/enums";
export default {
  name: "Classes",
  components: {
    ClassesEdit
  },
  data() {
    return {
      search: {
        schoolId:"",
        gradeId:"",
        classesId:"",
        status:1
      },
      tableHeight: 0,
      currentRowIndex: null,
      enums:enums,
      fileList:[],
      importWindow:false,
      importDisabled:false,
      schoolList:[],
      gradeList:[],
      classesList:[],
      editWindow:false,
      windowTitle:"新增",
      dataList: [],
      pageList: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  mounted() {
    if (this.$userSession.checkInstitutionId()) {
      this.handleDataList();
      this.getShoolName();
    }
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
    },
    handleShoolChange(item) {
      this.search.schoolId = item.id;
      this.search.schoolName = item.name;
    },
    handleGradeChange(item) {
      this.search.gradeId = item.id;
      this.search.gradeName = item.name;
    },
    handleClassChange(item) {
      this.search.classesId = item.id;
      this.search.className = item.name;
    },
    async getShoolName(){
      _schoolsList().then(res=>{
        if (res.errcode === 1 && res.data) {
          this.schoolList = res.data;
        }
      });
    },
    changeSchool(schoolId){
      if(!schoolId){
        return;
      }
      _gradesList({schoolId : schoolId}).then(res=>{
        this.search.schoolId = schoolId;
        this.search.gradeId = "";
        this.search.classesId = "";
        if (res.errcode === 1 && res.data){
          this.gradeList = res.data;
        }else{
          this.gradeList =[]
        }
      })
    },
    changeGrade(gradeId){
      if(!gradeId){
        return;
      }
      _classesList({schoolId:this.search.schoolId, gradeId : gradeId}).then(res=>{
        this.search.gradeId = gradeId;
        this.search.classesId = "";
        if (res.errcode === 1 && res.data){
          this.classesList = res.data;
        }else{
          this.classesList =[]
        }
      })
    },
    query() {
      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      _page({
        ...this.search,
        ...this.pageList,
      }).then(res => {
        this.dataList = res.data.records;
        this.pageList.total = res.data.total;
      }).catch(() => {});
    },
    handleEditStatus(row, index, targetValue){
      if(row && row.id){
        return new Promise((resolve,reject) => {
          this.$confirm(`是否确定${targetValue === 1 ? "启用" : "停用"}${row.name}吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then((result)=>{
            _updateStatus({id:row.id, status: targetValue}).then(res =>{
              if (res.errcode === 1) {
                this.handleDataList();
              }else {
                this.$message.error(res.errmsg);
                reject()
              }
            }).catch(() => {
              reject()
            });
          }).catch(function (e) {
            if (e === 'cancel' || e === 'close') {
              row.status = (targetValue === 1 ? 2 : 1);
            }
          })
        });
      }
    },
    async handleCreate() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      this.windowTitle = "新增";
      this.editWindow = true;
      this.$refs["edit"].handleModal();
    },
    handleEdit(row) {
      this.windowTitle = "编辑";
      this.editWindow = true;
      this.$refs['edit'].handleModal(row);
    },
    template(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      _template().then(res => {}).catch(error => {});
    },
    importData(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      this.fileList = [];
      this.importWindow = true;
    },
    handleChange(file, fileList){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return
      }
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.importDisabled = false;
    },
    handleCancle() {
      this.fileList = [];
      this.importWindow = false;
      this.importDisabled = false;
    },
    handleUpload(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return
      }else if(this.fileList && this.fileList.length === 0){
        return;
      }
      this.importDisabled = true;

      _upload({file: this.fileList[0].raw}).then(res=>{
        if (res && res.errcode && res.errcode === 1){
          this.fileList = [];
          this.importWindow = false;
          this.importDisabled = false;
          this.$message.success("上传成功");
          this.handleDataList()
        } else{
          this.importDisabled = false;
          this.$message({
            type: 'error',
            message: res.errmsg,
            duration: 3000,
            center: true
          });
        }
      }).catch(() => {
        this.importDisabled = false;
      });
    },
    submit(){
      this.$refs['edit'].handleSubmit();
    },
    handleSubmit(result) {
      if(!result){
        this.editWindow = result;
        this.handleDataList();
      }
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 6px;vertical-align: top;zoom: 1;}
/deep/ .el-table th {background-color: #f8f8f9;font-weight: bold;}
/deep/ .el-table thead {color: #515a6e;font-weight: 500;}
.el-table{border: 0px solid #ccc;}
/deep/ .el-dialog__body {padding: 5px 20px;}
/deep/ .el-table .el-table__cell {padding: 11px 0;}

</style>
